import { Route, Routes } from "react-router";
import Business from "./Business";
import BusinessDetail from "./BusinessDetail";

function BusinessRoutes() {
  return (
    <Routes>
      <Route path="" element={<Business />} />
      <Route path=":site" element={<BusinessDetail />}></Route>
    </Routes>
  );
}

export default BusinessRoutes;
